import { Grid_List } from '@app/post-lists/grid-list'
import { GT_Project } from '../../types/projects'
import { GT_Remaining_Work } from '../../types/remaining-work'
import { Ctx } from '@app/context'
import { List_Manage_Assembly_Presenter } from '@app/controllers/assembly-controller'

import ClickEvent = JQuery.ClickEvent
import { List_Manage_Status_Workers_Presenter } from '@app/controllers/workers-controller'
import { Goehler_Tool_REST_Client } from '@app/utils/rest-client'
import { GT_My_Running_Time } from '../../types/times'
import { handle_api_error } from '@app/utils/api-error'
import { App_Times_Controller } from '@app/controllers/times-controller'

export class Whiteboard_List extends Grid_List {
    type: string = 'grid-list'

    supports_dates: boolean = false
    supports_work: boolean = true
    supports_projects: boolean = true
    supports_week: boolean = false

    auto_reload: boolean = false

    private $progress: JQuery<HTMLElement> = jQuery( '#reload-progress' )

    assembly_presenter: List_Manage_Assembly_Presenter
    status_workers_presenter: List_Manage_Status_Workers_Presenter
    rest_client: Goehler_Tool_REST_Client

    times_controller: App_Times_Controller

    constructor( ctx: Ctx ) {
        super( ctx )

        this.set_projects( ctx.projects )
        this.set_remaining_work( ctx.remaining_work )
        this.set_dates( ctx.dates )

        this.init_columns()

        this.assembly_presenter = new List_Manage_Assembly_Presenter( this )
        this.status_workers_presenter = new List_Manage_Status_Workers_Presenter( this )
        this.rest_client = new Goehler_Tool_REST_Client()
        this.times_controller = new App_Times_Controller()

        this.render_results()
    }

    public ready() {
        this.init_actions()
        this.init_events()
        this.init_dropdowns()
        this.init_checkboxes()
        this.init_progress()
        this.assembly_presenter.ready()
        this.status_workers_presenter.ready()
        this.times_controller.ready()
    }

    /**
     * ============================
     *  Init
     * ============================
     */
    //#region Init

    public init_actions() {
        console.log( 'init whiteboard actions' )
        jQuery( '.button[data-action="reload-results"]' ).on(
            'click',
            () => { // {} wegen this
                this.ajax_reload_results()
            }
        )

        jQuery( '.button[data-action="update-list-work-view"]' ).on(
            'click',
            ( e: ClickEvent ) => {// {} wegen this
                jQuery( '.button[data-action="update-list-work-view"]' ).removeClass( 'active' )

                const active_button = e.currentTarget
                active_button.classList.add( 'active' )

                this.get_container().dataset.workView = active_button.dataset.view
            }
        )
    }

    public init_dropdowns() {
        jQuery( '#project-status-worker-edit' ).dropdown()
    }

    public init_checkboxes() {
        jQuery( '#list-auto-reload-checkbox' ).checkbox(
            {
                onChecked: () => {
                    this.auto_reload = true
                    this.start_reload_interval()
                },
                onUnchecked: () => {
                    this.clear_reload_interval()
                    this.auto_reload = false
                }
            }
        )

        jQuery( '#list-full-view-checkbox' ).checkbox(
            {
                onChecked: () => {
                    this.get_container().dataset.projectView = 'compact'
                },
                onUnchecked: () => {
                    this.get_container().dataset.projectView = 'full'
                }
            }
        )

        jQuery( '#list-substatus-view-checkbox' ).checkbox(
            {
                onChecked: () => {
                    this.get_container().dataset.substatusView = 'row'
                },
                onUnchecked: () => {
                    this.get_container().dataset.substatusView = 'column'
                }
            }
        )

        jQuery( '#list-active-projects-view-checkbox' ).checkbox(
            {
                onChecked: () => {
                    this.get_container().dataset.activeProjectsMode = 'true'
                },
                onUnchecked: () => {
                    this.get_container().dataset.activeProjectsMode = 'false'
                }
            }
        )
    }

    public init_progress() {
        this.$progress.progress(
            {

                // @ts-expect-error dumme Overloads
                onChange: ( percent: number[], value: number[], total: number ) => {
                    console.log( percent, value, total )

                    if ( value[0] === 0 ) {
                        console.log( 'letzte sekunde ab jetzt' )
                        this.clear_reload_interval()
                        window.setTimeout( () => {
                            this.ajax_reload_results()
                        }, 1000 )
                    }
                }
            }
        )
    }

    protected clear_work(): void {
        super.clear_work()

        const headers: HTMLElement[] = Array.from( this.get_container().querySelectorAll( '.work-header' ) )
        for ( const header of headers ) {
            header.innerHTML = '<span class="badge">keine Restarbeit vorhanden</span>'
        }
    }

    public render_results(): void {
        console.log( 'render results' )
        if ( ! gt_results.projects.length && ! gt_results.remaining_work.length ) {
            super.show_no_grid_results()
            return
        }

        this.clear_results()

        const project_results: Map<string, GT_Project[]> = this.map_projects( this.columns )
        const remaining_work_results: Map<string, GT_Remaining_Work[]> = this.map_remaining_work( this.columns )

        const promises: Promise<void>[] = [];

        for ( const key of this.columns.keys() ) {
            const unsorted_remaining_work: GT_Remaining_Work[] = remaining_work_results.get( key ) ?? []
            const sorted_remaining_work: GT_Remaining_Work[] = this.sort_remaining_work( unsorted_remaining_work, true )

            const unsorted_projects: GT_Project[] = project_results.get( key ) ?? []
            const sorted_projects: GT_Project[] = this.sort_projects( unsorted_projects, true )

            promises.push( this.render_column( key, [ ...sorted_remaining_work, ...sorted_projects ] ) )
        }

        Promise.all( promises ).then(
            () => {
                const button: HTMLElement | null = document.querySelector( '.button[data-action="reload-results"]' )
                if ( button ) {
                    button.classList.remove( 'disabled' )
                }

                void this.render_running_indicators()
            }
        )
    }

    private async render_running_indicators() {
        const TASK = 'Laden der laufenden Arbeitszeiten'

        console.log( 'render indicators' )

        // disable all indicators

        try {
            const response = await this.rest_client.get(
                'goehler-tool/v1/times/load-running-times'
            ) as number[]

            console.log( 'laufende Arbeitszeiten?', response )

            for ( const post_id of response ) {
                this.render_running_indicator( post_id )
            }
        } catch ( error ) {
            handle_api_error( error, TASK )
        }

        try {
            const response = await this.rest_client.get(
                'goehler-tool/v1/times/my-running-times'
            ) as GT_My_Running_Time[]

            console.log( 'eigene Arbeitszeit', response )

            app.times_controller.running_time = response[0] ?? null
            app.times_controller.check_my_running_times()
        } catch ( error ) {
            handle_api_error( error, TASK )
        }
    }

    render_running_indicator( post_id: number ): void {
        const containers = document.querySelectorAll( `.project-item[data-post-id="${post_id}"]` )

        if ( ! containers ) {
            return
        }

        for ( const container of Array.from( containers ) ) {
            container.classList.add( 'active' )
        }
    }

    private map_projects( columns: Map<string, HTMLElement> ): Map<string, GT_Project[]> {
        console.log( 'map projects' )

        const mapped_results: Map<string, GT_Project[]> = new Map()

        for ( const key of columns.keys() ) {
            console.log( 'key', key )

            mapped_results.set( key, gt_results.projects.filter( el => el.substatus.slug === key ) )
        }

        return mapped_results
    }

    private map_remaining_work( columns: Map<string, HTMLElement> ): Map<string, GT_Remaining_Work[]> {
        console.log( 'map remaining work' )

        const mapped_results: Map<string, GT_Remaining_Work[]> = new Map()

        for ( const key of columns.keys() ) {
            console.log( 'key', key )

            mapped_results.set( key, gt_results.remaining_work.filter( el => el.status.slug === key ) )
        }

        return mapped_results
    }

    protected async render_column( key: string, results: Array<GT_Project|GT_Remaining_Work> ) {
        if ( ! results.length ) {
            return
        }

        const column = this.columns.get( key ) as HTMLElement

        console.log( 'render column', key, column, results )

        if ( column.classList.contains( 'status-column' ) ) {
            this.render_work_header( column, results as GT_Remaining_Work[] )
        }

        for ( const result of results ) {
            this.render_result( key, result )
            await new Promise( resolve => setTimeout( resolve, 100 ) )
        }
    }

    private render_work_header( column: HTMLElement, results: GT_Remaining_Work[] ) {
        const header: HTMLElement|null = column.querySelector( '.work-header' )

        if ( ! header ) {
            return
        }

        header.innerHTML = ''

        const badge:HTMLSpanElement = document.createElement( 'span' )
        badge.classList.add( 'badge', 'status', 'status-work' )
        badge.innerHTML = `${results.length} Restarbeiten vorhanden`

        if ( results.length === 1 ) {
            badge.innerHTML = '1 Restarbeit vorhanden'
        }

        header.appendChild( badge )
    }

    protected render_project( key: string, result: GT_Project ) {
        console.log( 'render', result.post_type, result, key )

        const container: HTMLElement|null = document.querySelector( `.column[data-column="${key}"] .column-projects` )

        if ( ! container ) {
            return
        }

        const post: HTMLDivElement = document.createElement( 'div' )
        post.dataset.postId = result.post_id.toString()
        post.classList.add( 'column-item', 'project-item' )

        post.appendChild( this.create_project_schedule_title( post, result ) )
        post.appendChild( this.create_project_status_deadline( post, result ) )
        post.appendChild( this.create_project_assembly_dates( post, result ) )
        post.appendChild( this.create_project_remaining_work( post, result ) )
        post.appendChild( this.create_project_status_workers( post, result ) )

        container.append( post )
    }

    protected render_remaining_work( key: string, result: GT_Remaining_Work ) {
        console.log( 'render', result.post_type, result, key )

        const container: HTMLElement|null = document.querySelector( `.column[data-column="${key}"] .column-work` )

        if ( ! container ) {
            return
        }

        const post: HTMLDivElement = document.createElement( 'div' )
        post.dataset.postId = result.post_id.toString()
        post.classList.add( 'column-item', 'remaining-work-item' )

        post.appendChild( this.create_remaining_work_title( post, result ) )
        post.appendChild( this.create_remaining_work_project_title( post, result ) )

        container.append( post )
    }

    private create_project_status_deadline( _post:HTMLDivElement, project: GT_Project ):  HTMLDivElement {
        const div = document.createElement( 'div' )

        const { deadlines, status } = project

        div.classList.add( 'project-status-deadline' )

        if ( status?.slug === 'planning' ) {
            return div
        }

        if ( ! deadlines || ! ( status.slug in deadlines ) ) {
            return div
        }

        div.innerHTML = `
            Fertigstellung bis:<br>
            <span class="badge"><i class="calendar alternate outline icon"></i> ${format_date( deadlines[status.slug].date )}</span>
        `

        return div
    }

    private sort_remaining_work( results: GT_Remaining_Work[], include_paused: boolean = false ): GT_Remaining_Work[] {
        const priority: GT_Remaining_Work[] = results.filter(
            el => 'priority' in el.properties &&
                ! ( 'paused' in el.project!.properties )
        )

        const normal: GT_Remaining_Work[] = results.filter(
            el =>
                ! ( 'priority' in el.properties ) &&
                ! ( 'paused' in el.project!.properties )
        )

        const paused: GT_Remaining_Work[] = results.filter( el => 'paused' in el.project!.properties )

        if ( include_paused ) {
            return [ ...priority, ...normal, ...paused ]
        }

        return [ ...priority, ...normal ]
    }

    // priority > remaining work > normal > paused
    private sort_projects( results: GT_Project[], include_paused: boolean = false ): GT_Project[] {
        const priority: GT_Project[] = results.filter(
            el => 'priority' in el.properties &&
                ! ( 'paused' in el.properties )
        )

        const work: GT_Project[] = results.filter(
            el =>
                ! ( 'priority' in el.properties ) &&
                'remaining-work' in el.properties &&
                ! ( 'paused' in el.properties )
        )

        const normal: GT_Project[] = results.filter(
            el =>
                ! ( 'priority' in el.properties ) &&
                ! ( 'remaining-work' in el.properties ) &&
                ! ( 'paused' in el.properties )
        )

        const paused: GT_Project[] = results.filter( el => 'paused' in el.properties )

        if ( include_paused ) {
            return [ ...priority, ...work, ...normal, ...paused ]
        }

        return [ ...priority, ...work, ...normal ]
    }

    private clear_reload_interval() {
        if ( ! this.auto_reload ) {
            return
        }

        clearInterval( window.progress_interval )
    }

    private start_reload_interval() {
        if ( ! this.auto_reload ) {
            return
        }

        window.progress_interval = window.setInterval(
            () => {
                this.$progress.progress( 'decrement', 1 )
            },
            1000
        )
    }

    public reload_results() {
        this.ajax_reload_results()
    }

    public ajax_reload_results(): void {
        this.clear_results()
        this.clear_reload_interval()

        const button: HTMLElement|null = document.querySelector( '.button[data-action="reload-results"]' )

        if ( ! button ) {
            return
        }

        button.classList.add( 'loading', 'disabled' )

        const { ajax_url, nonce } = gt_ajax_object

        const data = {
            action: 'load_whiteboard_results',
            nonce,
        }

        console.log( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                button.classList.remove( 'loading' )

                this.set_projects( response.projects )
                this.set_dates( response.dates )
                this.render_results()
                this.$progress.progress( 'update progress', 59 )
                this.start_reload_interval()
            }
        )
    }
}
